module.exports = __webpack_public_path__ + "static/media/10_PepsiCo_logo.02d5daaf.svg";